// MSAL configuration for Office 365 authentication
export const msalConfig = {
  auth: {
    clientId: "864bc3b7-5653-459f-81c3-aa5bc840384f",
    authority: "https://login.microsoftonline.com/525e642e-1d34-4f1d-8854-9cb14406a311",
    redirectUri: "https://wscontroller-il.motiv8ai.io/",
    postLogoutRedirectUri: "https://wscontroller-il.motiv8ai.io/",
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) console.log(`MSAL (${level}): ${message}`);
      },
      piiLoggingEnabled: false,
      logLevel: "Verbose",
    }
  }
};

// Scopes for authentication
export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account"
};

// Additional scopes can be added as needed
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};